export class StepperActivationMessages {
  public error_certificate = 'stepper.error_certificate';
  public error_document = 'stepper.error_document';
  public error_cert_remove = 'stepper.error_cert_remove';


  constructor() {
  }
}
